
import React, { useState  , useCallback } from 'react';
import  "../../../LeadsSalesView/LeadsSalesProfileManagementView/LeadsProfileManagement.Style.scss" ; 
import Styles from './MatchedNewLeadCard.module.scss';
import  GeneralStyles  from "./MatchedLeadCard.scss"   ;
import { ButtonBase,  Tooltip } from '@material-ui/core';
import {
  LoadableImageComponant,
  SelectComponet, 
  CheckboxesComponent
} from '../../../../../Components' ; 
import {
  DefaultImagesEnum,
  LoadableImageEnum,
  UnitsOperationTypeEnum,
} from '../../../../../Enums';
import Button from '@material-ui/core/Button';
import { CopyToClipboardComponents } from '../../../../../ReusableComponents/UtilityComponents';
import {
  getDownloadableLink,
  GetParams,
  showError,
  showWarn,
} from '../../../../../Helper';

import { useTranslation } from 'react-i18next';
import bedIcon from '../../../../../assets/images/Propxicon/side-bed.svg';
import bathIcon from '../../../../../assets/images/icons/bath.svg';
import bookmarkIcon from '../../../../../assets/images/icons/bookmark.svg' ; 
import bookmarkCheckIcon from '../../../../../assets/images/icons/bookmark-check.svg' ; 
import { UnitTemplateDialogPreviewDialog } from  '../../../UnitsView/UnitsProfileManagementView/Dialogs/UnitTemplateDialog/UnitTemplateDialogPreviewDialog' ;   
import ProposalStartButton from '../../../SmartProposal/Utilities/ProposalThemeDialog/ProposalStartButton';
import useSmartProposalActions from "../../../SmartProposal/Hooks/useProposalStart";
  

export const MatchedNewLeadCard = ({
  data,
  reload,
  parentTranslationPath,
  translationPath,
  actionButtons,
  viewLeadHandler,
  isLease,
  unitInfo , 
  activeLead , 
  activeItem , 
  getIsSelectedCard , 
  onCardCheckboxClick,
  index ,
  isSmartProposalActive
}) => {

  const { t } = useTranslation([parentTranslationPath]);

   return (
     <>
       <div className={Styles.Card_wrapper} key={data?.unitId}>
         <div className={Styles.Card}>
           {isSmartProposalActive && (
             <span
               className="d-flex-v-center-h-end w-100 px-2"
               
             >
               <CheckboxesComponent
                 idRef={`unitsCheckboxItemRef${index + 1}`}
                 singleChecked={getIsSelectedCard(data.leadId)}
                 onSelectedCheckboxClicked={(event) => {
                   event.preventDefault();
                   if (!data?.lead?.contact_name?.email_address) {
                     showWarn(
                       t(`${translationPath}this-lead-havent-email-address-to-send-smart-proposal`)
                     );
                     return;
                   }

                   onCardCheckboxClick(index, data);
                 }}
                 title={!data?.lead?.contact_name?.email_address ? t(`${translationPath}this-lead-havent-email-address-to-send-smart-proposal`) : ''}
               />
             </span>
           )}
           <div className={Styles.Card_Content}>
             <div className={`${Styles.Card_section1} d-flex-h-between p`}>
               <div
                 className="mt-1"
                 onClick={() => viewLeadHandler("viewLead")}
               >
                 <LoadableImageComponant
                   classes={Styles.Card_Image}
                   type={LoadableImageEnum.div.key}
                   alt={`unit-image`}
                   src={
                     data?.unitImages?.fileId
                       ? getDownloadableLink(data?.unitImages?.fileId)
                       : DefaultImagesEnum.individual.defaultImg
                   }
                 />
               </div>
               <div className={`${Styles.Card__Main_info}`}>
                 <div className="d-flex-center flex-wrap  w-100">
                   <span className="w-100 flex d-flex-v-center-h-end flex-wrap">
                      {data?.matchType && data?.matchType === "Exact" ? (
                      <img src={bookmarkCheckIcon} alt="bath-Icon" />
                    ) : (
                      <span
                        className="mdi mdi-lightning-bolt"
                        style={{ color: "#FF8C00" }}
                      ></span>
                    )}
                    <span style={{ "font-size": "12px" }} className="">
                      {data?.matchType || ""}
                    </span>
                   </span>
                 </div>
                 <div className="mt-2 d-flex-column-center fa-start fw-bold my-3">
                   <span className="" style={{ "font-size": "16px" }}>
                     {data?.lead?.contact_name?.name}
                   </span>
                   <span className="details-text mt-1 hide-textarea c-primary fz-12px">
                     {t(`${translationPath}leadId`)}:
                     <Tooltip title={t(`${translationPath}copy`)}>
                       <CopyToClipboardComponents
                         data={data?.leadId}
                         childrenData={data?.leadId}
                       />
                     </Tooltip>
                   </span>
                   <span className="fz-12px c-primary fz-12px">
                     {data?.lead?.leadClass || ""}
                   </span>
                 </div>
               </div>
             </div>
             <div className={Styles.Capsules}>
               <div className={Styles.Solid_capsule}>
                 <span>
                   <img src={bedIcon} alt="bed-Icon" />
                 </span>
                 <span>{data?.leadData?.bedrooms || "-"}</span>
               </div>

               <div className={Styles.Solid_capsule}>
                 <span>
                   <img src={bathIcon} alt="bath-Icon" />
                 </span>
                 <span>{data?.leadData?.bathrooms || "-"}</span>
               </div>
               <div className={Styles.Solid_capsule}>
                 <span className="mdi mdi-cash-multiple flex d-flex-center">
                   <span className="px-2">
                     {`${data?.leadData?.budgetFrom || ""} - ${
                       data?.leadData?.budgetTo || ""
                     }`}
                   </span>
                 </span>
               </div>
             </div>
             <div className="px-1">
               <p>
                 <span className={`${GeneralStyles.Fw500} fw-bold  mr-2`}>
                   {t(`property-name`)}
                   {" :"}
                 </span>
                 <span>{data?.leadData?.property?.name || "N/A"}</span>
               </p>
               <p>
                 <span className={`${GeneralStyles.Fw500} fw-bold  mr-2`}>
                   {t(`unit-types`)}
                   {" :"}
                 </span>
                 <span>{data?.leadData?.unitTypes || "N/A"}</span>
               </p>
             </div>
           </div>
           <div className={Styles.Card_Buttons}>
             {actionButtons.sendSmartPropsal && activeItem ? (
               <div>
                 {data?.lead?.contact_name?.email_address ? (
                   <ProposalStartButton
                     singleUnit={activeItem}
                     buttonType="solid"
                     isLease={
                       data?.leadData?.operationType === "Sale" ? false : true
                     }
                     leadMatching={{
                       leadId: data?.leadId,
                       lead: data?.lead,
                       contactEmailAddress:
                         data?.lead?.contact_name?.email_address,
                       contactPhoneNumber:
                         data?.lead?.contact_name?.mobile ||
                         data?.lead?.contact_name?.phone,
                       contactWhatsApp:
                         data?.lead?.contact_name?.mobile ||
                         data?.lead?.contact_name?.phone,
                       unitId: data?.unitId || GetParams("id"),
                     }}
                     isLeadMatching
                     sendProposalToLead
                   />
                 ) : (
                   <div>
                     {" "}
                     <Button
                       onClick={() => {}}
                       disabled
                       className="btns theme-solid px-3"
                     >
                       <span className="mdi mdi-rocket px-1" />
                       <span>{t(`${translationPath}smart-proposal`)}</span>
                     </Button>
                   </div>
                 )}
               </div>
             ) : null}
             {}
           </div>
         </div>
         {viewLeadHandler && actionButtons.viewLead ? (
           <Button
             className={Styles.Side_popup_btn}
             onClick={() => viewLeadHandler({ clickAction: "viewLead" })}
           >
             <span className="mdi mdi-folder-open"></span>
           </Button>
         ) : null}
       </div>
     </>
   );
};
